import { httpClient } from '@/apis'
import { auth } from '@/apis/defineRouting.ts'
import axios from 'axios'
import type { AxiosResponse } from 'axios'
import type { authParams } from '@/apis/auth/types.ts'
import { useAuthStore } from '@/stores/authStore.ts'

const BASE_URL = import.meta.env.VITE_BASE_URL
export const refreshToken = async (params: {
  refresh_token: string
  clientId: string
  access_token: string
  username: string
}) => {
  const config = {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${params.access_token}`
    }
  }
  const authStore = useAuthStore()
  authStore.setIsRefreshingToken(true)
  const res: AxiosResponse = await axios.post(
    `${BASE_URL}/cop/auth/auth/refresh-token`,
    { refreshToken: params.refresh_token, clientId: params.clientId, username: params.username },
    config
  )
  authStore.setIsRefreshingToken(false)
  return res.data
}
export const authAPI = {
  async exchangeToken(params: authParams) {
    const res: AxiosResponse = await httpClient.post(`${auth.TOKEN_EXCHANGE}`, params)
    return res.data
  },
  async logOutServer(params: any) {
    const res: AxiosResponse = await httpClient.post(`${auth.LOGOUT}`, params)
  }
}
